/**
 * Configuración de Debug para el módulo Invoices/Orders
 * 
 * ⚠️ IMPORTANTE: Solo afecta a esta sección específica
 * 
 * Cuando está activo, permite acceder y usar todas las funcionalidades
 * de Invoices/Orders sin necesidad de tener los permisos configurados
 * en el backend.
 * 
 * 📖 Para instrucciones completas ver: README.md en esta carpeta
 */

export const INVOICES_DEBUG_CONFIG = {
  /**
   * DEBUG_PERMISSIONS
   * 
   * Cuando está en true:
   * - Permite ver la sección sin permiso invoices.view
   * - Muestra botón "Prefacturar" sin permiso pre-invoices.create
   * - Muestra acción "Editar" sin permiso pre-invoices.edit
   * - Muestra acción "Bloquear" sin permiso shipments.block
   * 
   * Útil para:
   * - Probar la UI completa sin configurar permisos en backend
   * - Desarrollo y testing de nuevas features
   * - Demos y presentaciones
   * 
   * ⚠️ Solo para desarrollo - Desactivar antes de producción
   * 
   * @default false
   */
  PERMISSIONS: false,

  /**
   * DEBUG_LOGS
   * 
   * Cuando está en true, muestra logs en consola sobre
   * las verificaciones de permisos en esta sección
   * 
   * @default false
   */
  LOGS: false,
} as const;

export const isInvoicesDebugEnabled = () => {
  // ✅ Modo debug controlado SOLO por esta bandera
  return INVOICES_DEBUG_CONFIG.PERMISSIONS;
};

export const isInvoicesDebugLogsEnabled = () => {
  // ✅ Logs controlados SOLO por esta bandera
  return INVOICES_DEBUG_CONFIG.LOGS;
};

